var uimetrics = uimetrics || {};

// =============================
// This thing's called a 'Recorder' because it used to hook into a number
// of javascript events and do some heavyweight logging, which we've since
// removed. At this point it's functionally a logging utility and a wrapper
// for Sentry. We should probably rename it.. and think about whether using
// Sentry directly is nicer
// =============================
uimetrics.Recorder = function() {};

// Deprecated, no-ops.
uimetrics.Recorder.prototype.init = function() {};
uimetrics.Recorder.prototype.initializeSentryIfNeeded = function() {};
uimetrics.Recorder.prototype.logMixpanelEvent = function() {};

/**
 * Captures an error, exception, or message to Sentry with optional context.
 * https://docs.sentry.io/platforms/javascript/enriching-events/context/#passing-context-directly
 * @param {string} msg - Custom message to log. If ex is undefined, msg will be captured instead.
 * @param {Exception | Error} [ex] - Optional exception or error to capture
 * @param {object} [captureContext] - Optional context (extra data) to include with the error or 
 *      message. e.g. For captureContext = `{ tags: { key: "value"} }`, first-level tags 
 *      will be indexed for `key:value` search in Sentry.
 */
uimetrics.Recorder.prototype.logError = function(msg, ex, captureContext) {
    console.log('UIM ERR: ' + msg, ex, captureContext);
    try {
        if (ex) {
            window.Sentry && window.Sentry.captureException(ex, captureContext);
        } else {
            window.Sentry && window.Sentry.captureMessage(msg, captureContext);
        }
    } catch (err) {
      console.log(err);
    }
};
